/**
 * Muestra el botón de plantillas de utilidad de Messenger si: inbox de Facebook y NO es Instagram DM.
 * No se condiciona a canReply ni a si el contacto ya escribió, porque una conversación de Facebook
 * solo existe tras un mensaje entrante. El gating por nota privada va aparte.
 */
export const shouldShowMessengerButtonTemplates = ({
  isFacebookInbox,
  isInstagramDMConversation,
}) => {
  if (isFacebookInbox && !isInstagramDMConversation) {
    return true;
  }
  return false;
};

/**
 * Fallback para cargar plantillas de una conversación de Facebook si se pierde el broadcast
 * `inbox.templates_updated`. Refresca solo si: inbox de Facebook (no IG DM), no intentado antes y
 * plantillas sin cargar. Usa `templatesLoaded` (no "tiene plantillas"): `[]` sincronizado ya cuenta como cargado.
 */
export const shouldRefreshMessengerTemplates = ({
  isFacebookInbox,
  isInstagramDMConversation,
  alreadyRefreshed,
  templatesLoaded,
}) => {
  if (!isFacebookInbox || isInstagramDMConversation) {
    return false;
  }
  if (alreadyRefreshed) {
    return false;
  }
  return !templatesLoaded;
};

/**
 * Mapea un mensaje de plantilla (FB/WhatsApp) de snake_case (almacenado) a camelCase (API de envío).
 * Sin este mapeo el reintento crearía un mensaje vacío sin plantilla que, fuera de la ventana, se
 * bloquea. Devuelve null si el mensaje no es plantilla (sin template_params), para no alterar el reintento.
 */
export const buildTemplateRetryPayload = messageData => {
  const templateParams = messageData?.additional_attributes?.template_params;
  if (!templateParams) {
    return null;
  }
  return {
    ...messageData,
    conversationId: messageData.conversation_id,
    message: messageData.content,
    contentAttributes: messageData.content_attributes,
    templateParams,
  };
};

/**
 * Construye el payload de actualización del inbox desde el evento `inbox.templates_updated`.
 * Anti-clobber: solo incluye `message_templates` si NO es null/undefined, para no borrar las del
 * store (un `[]` sí es válido y se aplica). Devuelve null si el evento no trae `inbox_id`.
 */
export const buildInboxUpdatePayload = data => {
  if (data?.inbox_id == null) {
    return null;
  }
  const payload = { id: data.inbox_id };
  if (data.message_templates != null) {
    payload.message_templates = data.message_templates;
  }
  return payload;
};

/**
 * True si el mensaje es plantilla de Facebook (`additional_attributes.template_params` + inbox de FB).
 * Marcador único de un envío de plantilla: evita representarlo como "mensaje interactivo" aunque traiga
 * `content_attributes.items` (botones), en la burbuja (Message.vue) y la vista previa (ConversationCard).
 */
export const isFacebookTemplateMessage = ({ message, isFacebookInbox }) =>
  !!message?.additional_attributes?.template_params && !!isFacebookInbox;
